import React from 'react'
import { Input, Typography } from 'antd'
import PropTypes from 'prop-types'

import { StyledNoMarginFormItem } from '../../../core/components/styled'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormItemLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

const FormTextareaInput = ({
  name,
  label,
  rules,
  labelAbove,
  showColon,
  ...rest
}) => (
  <StyledNoMarginFormItem
    layout="vertical"
    labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    fieldKey={name}
    name={name}
    colon
    label={
      <Typography.Text>{formatFormItemLabel(label, showColon)}</Typography.Text>
    }
    rules={rules}
  >
    <Input.TextArea {...rest} />
  </StyledNoMarginFormItem>
)

FormTextareaInput.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  labelAbove: PropTypes.bool,
  showColon: PropTypes.bool,
}

FormTextareaInput.defaultProps = {
  label: '',
  rules: undefined,
  labelAbove: false,
  showColon: false,
}

export default FormTextareaInput
